import { useCallback, useState } from 'react'
import { showAlert } from '../../utility/SweetAlert'
import ApiService from '../../services/ApiService'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

const InteractorFundWithdrawList = () => {
  const { t } = useTranslation()
  const [fundWithdrawData, setFundWithdrawData] = useState([])
  const [fundWithdrawPages, setFundWithdrawPages] = useState({
    currentPage: 1,
    limitProduct: 0,
    totalPages: 1,
    totalItem: 0,
  })
  const { account } = useSelector((state) => state.account)

  const fundWithdrawSearch = useCallback(
    (payload, setLoading = () => {}) => {
      let payloadRequest = { ...payload, keywords: { source: 'SELLER', account_uid: account.uid } }
      setLoading(true)
      ApiService.jsonRequest('/fund-withdraw/search', payloadRequest, (response) => {
        setLoading(false)
        if (response.status_code === 200) {
          const { pages } = response.data
          setFundWithdrawPages({
            currentPage: pages.page,
            limitProduct: pages.limit,
            totalPages: pages.total_pages,
            totalItem: pages.total_items,
          })
          setFundWithdrawData(response.data?.items)
        } else {
          showAlert({
            icon: 'error',
            message: t(`response_message.${response.messages}`),
            timer: false,
          })
        }
      })
    },
    [account.uid, t],
  )

  return { fundWithdrawPages, fundWithdrawData, fundWithdrawSearch, setFundWithdrawData }
}

export default InteractorFundWithdrawList
